import React, { useState } from "react";
import classes from "./PartnershipPrograms.module.css";
import partnershipPrograms from "./partnershipContent";
import AnimatedCard from "../UI/AnimatedCard/AnimatedCard";
import ProgramIcon, { getProgramIconKey } from "./ProgramIcon";

const pairs = [];
for (let i = 0; i < partnershipPrograms.length; i += 2) {
  pairs.push({
    left: partnershipPrograms[i],
    right: partnershipPrograms[i + 1],
    leftIndex: i,
    rightIndex: i + 1,
  });
}

const PartnershipPrograms = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    if (index == null) return;
    setOpenIndex((current) => (current === index ? -1 : index));
  };

  return (
    <div className={classes.section}>
      <AnimatedCard className={classes.headingWrap}>
        <h2 className={classes.sectionTitle}>
          Partnership Programs &amp; Initiatives
        </h2>
      </AnimatedCard>

      <div className={classes.list}>
        {pairs.map((pair) => {
          const leftOpen = openIndex === pair.leftIndex;
          const rightOpen = openIndex === pair.rightIndex;
          const openProgram = leftOpen
            ? pair.left
            : rightOpen
            ? pair.right
            : null;

          return (
            <AnimatedCard key={pair.left.title} className={classes.pair}>
              <div className={classes.row}>
                <button
                  type="button"
                  className={`${classes.leftCard} ${
                    leftOpen ? classes.activeLeft : ""
                  }`}
                  aria-expanded={leftOpen}
                  onClick={() => toggle(pair.leftIndex)}
                >
                  <ProgramIcon
                    name={getProgramIconKey(pair.leftIndex)}
                    className={`${classes.cardIcon} ${classes.yellow}`}
                  />
                  <div className={classes.number + " " + classes.yellow}>
                    {String(pair.leftIndex + 1).padStart(2, "0")}
                  </div>
                  <div className={classes.label + " " + classes.yellow}>
                    {pair.left.title}
                  </div>
                </button>

                <ProgramIcon
                  name="partnership"
                  className={classes.centerIcon}
                />

                {pair.right ? (
                  <button
                    type="button"
                    className={`${classes.rightCard} ${
                      rightOpen ? classes.activeRight : ""
                    }`}
                    aria-expanded={rightOpen}
                    onClick={() => toggle(pair.rightIndex)}
                  >
                    <ProgramIcon
                      name={getProgramIconKey(pair.rightIndex)}
                      className={`${classes.cardIcon} ${classes.blue}`}
                    />
                    <div className={classes.number + " " + classes.blue}>
                      {String(pair.rightIndex + 1).padStart(2, "0")}
                    </div>
                    <div className={classes.label + " " + classes.blue}>
                      {pair.right.title}
                    </div>
                  </button>
                ) : (
                  <div className={classes.rightCardPlaceholder} />
                )}
              </div>

              <div
                className={`${classes.detail} ${
                  openProgram ? classes.detailOpen : ""
                }`}
              >
                <div className={classes.detailInner}>
                  {openProgram && (
                    <>
                      <h4 className={classes.detailTitle}>
                        {openProgram.title}
                      </h4>
                      {openProgram.paragraphs.map((paragraph, paragraphIndex) => (
                        <p key={`${openProgram.title}-${paragraphIndex}`}>
                          {paragraph}
                        </p>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </AnimatedCard>
          );
        })}
      </div>
    </div>
  );
};

export default PartnershipPrograms;
